import { Injectable } from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {CountedAndPaginated} from "../interface/response/counted-and-paginated";
import {Tag} from "../interface/tag";
import {FileManagerTag} from "../interface/file-manager-tag";
import {HttpClient} from "@angular/common/http";
import {FilterService} from "./filter.service";
import {take} from "rxjs/operators";
import {ListResponse} from "../interface/response/list-response";
import {Uuid} from "../interface/response/uuid";

@Injectable({
  providedIn: 'root'
})
export class FileManagerTagService {
  public readonly tagListSubject: ReplaySubject<CountedAndPaginated<FileManagerTag>>
    = new ReplaySubject<CountedAndPaginated<FileManagerTag>>(1);
  public readonly tagsDictSubject: ReplaySubject<Array<FileManagerTag>> = new ReplaySubject();

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
  ) {
    this.tagsDictSubject = new ReplaySubject<Array<FileManagerTag>>(1);
    this.loadDict();
  }

  public loadDict(): void {
    this.httpClient.get('/rest/crm/file-manager/dictionary/tag')
      .pipe(take(1))
      .subscribe((result: ListResponse<FileManagerTag>) => {
        this.tagsDictSubject.next(result.items);
      });
  }

  public getTagDictSubject(): ReplaySubject<Array<FileManagerTag>> {
    return this.tagsDictSubject;
  }

  public send(formData: object, uuid?: string ): Observable<any> {
    if (uuid) {
      return this.httpClient.put(`/rest/crm/file-manager/tag/${uuid}`, formData)
        .pipe(
          take(1)
        ) as Observable<Uuid>;
    } else {
      return this.httpClient.post(`/rest/crm/file-manager/tag`, formData)
        .pipe(
          take(1)
        );
    }
  }

  public loadList(page: number, pageSize: number, filters: object): void {
    this.httpClient.get(`/rest/crm/file-manager/tag?page=${page + 1}&pageSize=${pageSize}&` + this.filterService.parseFilters(filters))
      .pipe(take(1))
      .subscribe((result: CountedAndPaginated<FileManagerTag>) => {
        this.tagListSubject.next(result);
      });
  }

  public getTagListSubject(): ReplaySubject<CountedAndPaginated<FileManagerTag>> {
    return this.tagListSubject;
  }
}
